import React, {ChangeEvent, useEffect, useState} from 'react';

import './ProjectList.css';
import Accordion from 'react-bootstrap/Accordion';
import {Box} from '@mui/material';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

import 'bootstrap/dist/css/bootstrap.min.css';
import {
  FilterCondition,
  getApiSort,
  requestQuery,
  ServerResponse,
  translateToQueryApiOperator,
  typeOperatorMap
} from "../framework/QueryApi";
import {Button} from "react-bootstrap";
import {ProjectListing} from "./model/ProjectListing";
import {
  AmsDataGrid,
  AmsDataGridPageModel,
  AmsDataGridSortItem,
  DEFAULT_PAGE_SIZE
} from "../framework/component/data-grid/AmsDataGrid";
import {projectListColumns} from "./ProjectListColumns";
import {AxiosResponse} from "axios";

const fieldOptions = ['Application ID', 'Institute', 'Title', 'Country'];
const PAGE_TITLE = "AMS - Project";

//  TODO  Move to Filter UI component when created
type Filter = {
  field: string;
  operator: string;
  value: string;
};

const fields = new Map<string, string>([
  ['Application ID', 'applicationId'],
  ['Title', 'title'],
  ['Institute', 'instituteName'],
  ['Country', 'countryName'],
]);

function buildApiFilter(filters: Filter[]) {
  return filters
    .filter(f => f.field && f.value)
    .map(f => {
      const apiFieldCode = fields.get(f.field);
      const apiOperator = translateToQueryApiOperator(f.operator);
      if (!apiFieldCode || !apiOperator) {
        throw Error(`Unknown field or operator: ${f.field}, ${f.operator}`);
      } else {
        return new FilterCondition(apiFieldCode, apiOperator, f.value)
      }
  });
}

const INITIAL_FILTER: Filter = { field: "Application ID", operator: "equals", value: ""};
const INITIAL_SORT = [{ field: "applicationId", direction: "asc"}];
const ProjectList = () => {
      const [rows, setRows] = useState<ProjectListing[]>([]);
      const [filters, setFilters] = useState<Filter[]>([INITIAL_FILTER]);
      const [rowCount, setRowCount] = useState(0);
      const [loading, setLoading] = useState(false);
      const [pageNo, setPageNo] = useState(0)
      const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

      const [sort, setSort] = useState<AmsDataGridSortItem[]>(INITIAL_SORT);

      const addFilter = () => {
        setFilters([...filters, {field: '', operator: '', value: ''}]);
      };

      const removeFilter = (index: number) => {
        setFilters(filters.filter((_, i) => i !== index));
      };

      const handleFilterChange = (index: number, key: keyof Filter, value: string) => {
        filters[index][key] = value;
        setFilters(filters.slice());
      };

      const handlePaginationChange = (model: AmsDataGridPageModel) => {
        setPageNo(model.page)
        setPageSize(model.pageSize)
      };

      const handleSortChange = (model: AmsDataGridSortItem[]) => {
        setSort(model);
      };

      const populateDataGrid = (response: AxiosResponse) => {
        const data: ServerResponse = response.data;

        setRows(data.data);
        setRowCount(data.meta.totalRecords);
        setLoading(false);

      };

      const fetchData = () => {
        setLoading(true);
        requestQuery('projectListing', buildApiFilter(filters), [], getApiSort(sort), populateDataGrid, pageNo, pageSize)
          .catch(e => console.log("Failed to fetch project listing", e));
      }

      const handleSearch = () => {
        fetchData();
      };

      document.title = PAGE_TITLE;

      useEffect(() => {
        fetchData();
      }, [sort, pageNo, pageSize]);

      return (
          <Box sx={{height: 500, width: '100%'}}>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Project Search</Accordion.Header>
                <Accordion.Body>

                  <Row className="mb-1 align-items-end">
                    <Col md={1}></Col>
                    <Col md={3}>Field</Col>
                    <Col md={2}>Operator</Col>
                    <Col md={3}>Value</Col>
                    <Col md={2}></Col>
                  </Row>
                  {filters.map((filter: Filter, index) => (
                      <Row key={index} className="mb-3 align-items-end">
                        <Col md={1}>
                          <Row><Col className={"text-end"}><i className="h3 bi bi-plus text-success"
                                                              role={"button"}
                                                              onClick={addFilter}></i>
                            <i className="h3 bi bi-x text-danger" role={"button"}
                               onClick={() => removeFilter(index)}></i></Col>
                          </Row>
                        </Col>
                        <Col md={3}>
                          <Form.Select
                              value={filter.field}
                              onChange={(e: ChangeEvent<HTMLSelectElement>) => handleFilterChange(index, "field", e.target.value)}>
                            <option value="">Select Field</option>
                            {fieldOptions.map((field) => (
                                <option key={field} value={field}>
                                  {field}
                                </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col md={2}>
                          <Form.Select
                              value={filter.operator}
                              onChange={(e: ChangeEvent<HTMLSelectElement>) => handleFilterChange(index, "operator", e.target.value)}>
                            <option value="">Select Operator</option>
                            {(typeOperatorMap.get(projectListColumns.find(c =>
                                c.field == fields.get(filter.field))?.type ?? '') ?? [])
                                .map((op) => (
                                <option key={op} value={op}>
                                  {op}
                                </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col md={3}>
                          <Form.Control
                              type="text"
                              placeholder="Enter value"
                              value={filter.value}
                              onChange={(e: ChangeEvent<HTMLInputElement>) => handleFilterChange(index, "value", e.target.value)}/>
                        </Col>
                      </Row>
                  ))}
                  {filters.length == 0 &&
                      <Button variant="primary" className={"mt-4"} onClick={addFilter}>Add a
                        Filter</Button>
                  }

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className={"text-center"}><Button variant="primary" className={"mt-3 mb-3"}
                                                   onClick={handleSearch}>Search</Button></div>
            <div style={{display: 'flex', flexDirection: 'column', maxHeight: 600, minHeight: 400}}>
              <AmsDataGrid
                  rows={rows}
                  rowIdFunction={(row: ProjectListing) => row.applicationId}
                  columnModel={projectListColumns}
                  rowCount={rowCount}
                  paginationChangeFunction={handlePaginationChange}
                  sortChangeFunction={handleSortChange}
                  loadingFlag={loading}
                  initialSort={INITIAL_SORT}
              />
            </div>
          </Box>
);
}
;


export default ProjectList;
